












































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MapGameRole } from '@/core/constants';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { ApiPermissions } from '@/core/security/Permissions';
import { UpdateRealmAllowedSecurityLevelRequest, Realm, GameRole } from '@/types/apiServerContract';

@Component
export default class UpdateRealmSecurity extends Vue {
	@Prop({ required: true }) realm!: Realm;
	@Prop({ required: true }) SecurityRoles!: any[];

	permissions: string[] = [ApiPermissions.Realm.EditRealmSecurity];
	loading = false;
	realmSecurityRequest: UpdateRealmAllowedSecurityLevelRequest = {
	    security: -1,
	    realmId: -1
	};

	async UpdateRealmSecurity() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to save these changes?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.realmSecurityRequest.realmId = this.realm.id;

	    try {
	        this.loading = true;
	        await RealmsModule.UpdateAllowedSecurityLevel(this.realmSecurityRequest);
	    } finally {
	        this.loading = false;
	    }

	    this.$bvToast.toast('Realm successfully updated', {
	        variant: 'success',
	        title: 'Success'
	    });

	    this.Reset();
	}

	Reset() {
	    this.realmSecurityRequest = {
	        security: -1,
	        realmId: -1
	    };
	    this.$nextTick(() => {
	        (this.$refs.UpdateRealmSecurity as any).reset();
	    });
	}

	MapGameRole(role: GameRole) {
	    return MapGameRole(role);
	}
}
